/* eslint-disable max-len */
import {
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType,
    PrimaryButton,
    Stack,
} from '@fluentui/react';
import React, { useState } from 'react';
import { appStyles } from '../../../../helpers';
import { DefaultFolderModalStep } from '../../../../store/reducers/defaultFolder/reducer';
import { useAppDispatch, useAppSelector } from '../../../../store';
import { selectDefaultFolderModalStep } from '../../../../store/selectors/defaultFolder';
import { selectTranslate } from '../../../../store/selectors/ui';
import {
    setDefaultFolderModalStep,
    setFormDefaultFolderCircles,
} from '../../../../store/actions/defaultFolder/actionCreators';
import { selectCircles } from '../../../../store/selectors/nextcloud';
import { Circle } from '../../../../services/microsoft/msGraphApi';
import { CircleSelector } from '../../../common/CircleSelector';

export const CircleSelectionModal = () => {
    const dispatch = useAppDispatch();
    const defaultFolderModalStep = useAppSelector(selectDefaultFolderModalStep);
    const circles = useAppSelector(selectCircles);
    const translate = useAppSelector(selectTranslate);

    const [selectedCircles, setSelectedCircles] = useState<Circle[]>([]);

    const isCirclesDialogOpen =
        defaultFolderModalStep === DefaultFolderModalStep.CircleSelection;

    const handleSelectionChange = (newSelectedCircles: Circle[]) => {
        setSelectedCircles(newSelectedCircles);
    };

    return (
        <Dialog
            styles={appStyles.DialogStyle}
            hidden={!isCirclesDialogOpen}
            onDismiss={() =>
                dispatch(
                    setDefaultFolderModalStep(DefaultFolderModalStep.SetFolder),
                )
            }
            dialogContentProps={{
                type: DialogType.normal,
                title: translate('share_with_teams'),
            }}
        >
            <Stack tokens={{ childrenGap: 8 }}>
                <CircleSelector
                    circles={circles}
                    selectedCircleIds={selectedCircles.map(
                        (circle) => circle.id,
                    )}
                    onSelectionChange={handleSelectionChange}
                    searchPlaceholder={translate('search')}
                    dropdownPlaceholder={translate('no_team_selected')}
                    isMultiSelect={false}
                />
            </Stack>
            <DialogFooter>
                <PrimaryButton
                    text={translate('confirm')}
                    onClick={async () => {
                        dispatch(
                            setFormDefaultFolderCircles(selectedCircles[0]),
                        );
                        dispatch(
                            setDefaultFolderModalStep(
                                DefaultFolderModalStep.Confirmation,
                            ),
                        );
                    }}
                />
                <DefaultButton
                    text={translate('cancel')}
                    onClick={() =>
                        dispatch(
                            setDefaultFolderModalStep(
                                DefaultFolderModalStep.SetFolder,
                            ),
                        )
                    }
                />
            </DialogFooter>
        </Dialog>
    );
};
